// CtaChips — набір CTA-кнопок (predictive actions від CR Engine).
import "../../styles/CtaChips.css";

export default function CtaChips({ ctas = [], loading, onClick }) {
  return (
    <div className="ctas">
      {ctas.map((c) => (
        <button
          key={c.id}
          className="ctaBtn"
          onClick={() => onClick(c)}
          disabled={loading || c.disabled}
          title={c.disabled ? "Недоступно" : c.label}
        >
          <span className="ctaLabel">{c.label}</span>
          {c.sublabel ? <span className="ctaSub">{c.sublabel}</span> : null}
        </button>
      ))}
    </div>
  );
}
